import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VehicleType } from 'components/common/CommonTypes';
import { PolicyState, VehicleState as Vehicle } from 'state/types/vehicle';

export type VehicleState = {
    vehicleList: Vehicle[];
    selectedVehicleIndex: number;
    selectedPolicy?: PolicyState;
};

const initialState: VehicleState = {
    vehicleList: [],
    selectedVehicleIndex: -1 // replace with vehicle
};

export const vehicleSlice = createSlice({
    name: 'vehicles',
    initialState,
    reducers: {
        setVehicles: (state, action: PayloadAction<VehicleType[]>) => {
            state.vehicleList = action.payload;
        },
        setSelectedVehicle: (state, action: PayloadAction<number>) => {
            state.selectedVehicleIndex = action.payload; // what can be used as vehicle Id instead?
        },
        setSelectedPolicy: (state, action: PayloadAction<string>) => {
            // should it set vehicle as well?
            state.selectedPolicy = state.vehicleList
                .flatMap((v) => v.policies)
                .find((p) => p.reference === action.payload);
        }
    }
});

export const { setVehicles, setSelectedVehicle, setSelectedPolicy } =
    vehicleSlice.actions;
